<template>
    <form @submit.prevent="save">
        <div class="row main-form">
            <custom-input
                v-model="password"
                :title="$t('ACCOUNT_CARDS__PASSWORD')"
                @clear="password = ''"
                inputType="password"
                :isError="passwordIsError"
                errorMessage="Should be 5-100 symbols"
                helperText="* Minimum 5 symbols"
                isRequired
            />
            <custom-input
                v-model="confirm"
                :title="$t('ACCOUNT_CARDS__CONFIRM_PASSWORD')"
                @clear="confirm = ''"
                inputType="password"
                :isError="confirmIsError"
                errorMessage="Passwords don't match"
                isRequired
            />
        </div>
        <button class="btn">{{ $t('ACCOUNT_CARDS__SAVE') }}</button>
    </form>
</template>

<script>
import CustomInput from '@/components/ReusableComponents/CustomInput/CustomInput.vue'
import axios from '@/Helpers/AxiosInstance.js'
export default {
    components: {
        CustomInput,
    },
    props: {
        cardID: Number,
    },
    data() {
        return {
            password: '',
            passwordIsError: false,
            confirm: '',
            confirmIsError: false,
        }
    },
    methods: {
        save() {
            if(this.checkErrors()) return
            axios
                .post('WebShop/EditPassword', {
                    cardId: this.cardID,
                    password: this.password,
                })
                .then(resp => {
                    if(resp.data.status == 1) {
                        this.$emit('showMessage', {
                            purpose: 'success',
                            text: 'New Password Saved!',
                        })
                    }
                    else {
                        this.showErrors(resp.data.status)
                    }
                })
                .catch(() => this.showErrors())
        },
        checkErrors() {
            if(this.password.length < 5 || this.password.length > 100) {
                this.passwordIsError = true
                return true
            }
            else this.passwordIsError = false
            if(this.password != this.confirm && this.confirm) this.confirmIsError = true
            else this.confirmIsError = false
            return this.passwordIsError || this.confirmIsError
        },
        showErrors(status) {
            var text = 'An Error Occurred While Reseting Password!'
            var code = this.statusCodes.filter(e => e.key == status)[0]
            if (code) text = this.$t('STATUS-CODE__' + code.value)
            this.$emit('showMessage', {
                purpose: 'error',
                text: text,
            })
        }
    },
    computed: {
        statusCodes() {
            return this.$store.state.statusCodes
        }
    },
    watch: {
        password() {
            this.checkErrors()
        },
        confirm() {
            this.checkErrors()
        }
    }
}
</script>

<style scoped lang="scss">
form {
    margin-top: 100 * $rem;

    .row {
        display: flex;
        margin-bottom: 30 * $rem;

        /deep/ label {
            margin-right: 15 * $rem;
            width: 220 * $rem;
        }
    }

    .btn {
        margin-top: 20 * $rem;
        width: 150 * $rem;
        height: 40 * $rem;
        font-size: 16 * $rem;
    }
}
</style>
